var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCurrency = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  "aria-hidden": "true",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#1F2124",
  d: "M15.528 14.96c0 1.712-1.184 2.88-3.104 3.072v1.92h-1.408V18a5.6 5.6 0 0 1-3.184-1.584l1.136-1.36c.896.864 2 1.264 2.928 1.264.944 0 1.6-.464 1.6-1.216 0-.864-.656-1.2-2.032-1.632-1.776-.544-3.392-1.136-3.392-3.12 0-1.6 1.072-2.8 2.944-2.992V5.344h1.408v2.064c1.024.192 2.08.672 2.816 1.264l-1.088 1.344c-.864-.624-1.808-.912-2.544-.912-.928 0-1.52.416-1.52 1.12 0 .752.704 1.072 1.92 1.456 2.08.656 3.52 1.2 3.52 3.28"
})));
export default SvgCurrency;